import React, { useEffect } from "react";
// import SharedRepositories from "../../components/SharedRepositories";
import HeaderImage from "../../components/HeaderImage";
import { Link } from "react-router-dom";
import HoverLinkPreview from "../../components/HoverLinkPreview";

const SharedPublishing: React.FC = () => {
  // const handleDocumentClick = () => {
  //   window.open("https://publishnow.wacren.net/", "_blank");
  // };

  useEffect(() => {
    const element = document.getElementById("shared-repo");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  const buttons = [
    {
      label: "GhAFoST",
      link: "https://ghafost.wacren.net",
    },
    // {
    //   label: "Working Groups",
    //   link: "/about-us/working-groups",
    // },
    {
      label: "COPPHA",
      link: "https://coppha.wacren.net",
    },
    {
      label: "African Journal of Bioethics",
      link: "/",
    },
  ];

  return (
    <>
      <HeaderImage image="/assets/images/services/publishnow-bg.jpg" />

      <div className="max-w-4xl mx-auto mb-12 p-6" id="shared-repo">
        <div className="mb-8">
          <h2 className="text-center text-xxl font-semibold text-foreground mb-4">
            PUBLISHNOW - PUBLISHING PLATFORM
          </h2>

          <p className="text-sm text-foreground mb-4">
            PublishNow is a platform designed to facilitate the entire
            publishing process. It offers a streamlined workflow for managing
            submissions, peer reviews, and the publication of scholarly works.
            PublishNow enables researchers and institutions to manage the
            publishing lifecycle efficiently, from submission to final
            publication, ensuring high-quality output and a smooth user
            experience.
          </p>
          <p className="text-sm text-foreground mb-4">
            The institutions and groups below have subscribed to the PublishNow
            service. Click on the logos to open their webpages to read more on
            their publications in PublishNow.
          </p>
          <p className="text-sm text-foreground mb-4">
            If you want to subscribe to this service, please send an email to{" "}
            <Link
              to="mailto:devops@wacren.net"
              target="_blank"
              className="text-primary"
            >
              devops@wacren.net
            </Link>{" "}
            or{" "}
            <Link
              to="mailto:support@wacren.net"
              target="_blank"
              className="text-primary"
            >
              support@wacren.net
            </Link>
            .
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {buttons.map((button, index) => (
            <HoverLinkPreview
              key={index}
              url={button.link}
              className="block text-center border border-foreground px-4 py-3 rounded-md text-foreground transition duration-300 hover:text-primary"
            >
              {button.label}
            </HoverLinkPreview>
          ))}
        </div>
      </div>
    </>
  );
};

export default SharedPublishing;
